import type { VisibilityState } from '@tanstack/react-table';
import type { DataTableColumnDef } from 'components/data-table';

/**
 * Subtracts Held and Subtracts in Tract, right after the Tract's name on the Assets and
 * Property Allocations tables, as their exports place them: for a Tract held in part, the two
 * counts its "(N of M Subtracts)" label shows; for one held whole, all its Subtracts. Hidden
 * until shown through Show/Hide columns ({@link SUBTRACT_COUNT_COLUMNS_HIDDEN}). Neither sorts
 * nor filters: the server counts the page it returns, after it has sorted and filtered.
 *
 * @return {object[]} The two DataTable column definitions.
 */
export function subtractCountColumns<
  T extends Record<string, unknown>,
>(): DataTableColumnDef<T>[] {
  return [
    {
      accessorKey: 'subtractsHeld',
      header: 'Subtracts Held',
      size: 140,
      meta: { type: 'integer' },
      enableSorting: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: 'subtractsInTract',
      header: 'Subtracts in Tract',
      size: 150,
      meta: { type: 'integer' },
      enableSorting: false,
      enableColumnFilter: false,
    },
  ];
}

/** {@link subtractCountColumns}' initial visibility: hidden. */
export const SUBTRACT_COUNT_COLUMNS_HIDDEN: VisibilityState = {
  subtractsHeld: false,
  subtractsInTract: false,
};
